// The flow Pages tab (flow language).
export const T = {
  en_GB: {
    error: "Error",
    failedToReorderPages: "Failed to reorder pages",
    ok: "OK",
    failedToDeletePage: "Failed to delete page",
    pagesDescription: "Pages render in this order. The brackets show the parts that repeat.",
    internal: "Internal",
    public: "Public",
    dragHint:
      "Drag to reorder. A page cannot leave its bracket — its type is fixed when it is created.",
    deletePage: "Delete Page",
    deletePageConfirmation: (name: string) => `Are you sure you want to delete "${name}"?`,
    willAlsoDelete: (count: number) => ` This will also delete ${count} component(s) on this page.`,
    cancel: "Cancel",
    delete: "Delete",
  },
  nb_NO: {
    error: "Feil",
    failedToReorderPages: "Kunne ikke endre siderekkefølge",
    ok: "OK",
    failedToDeletePage: "Kunne ikke slette side",
    pagesDescription: "Sidene vises i denne rekkefølgen. Klammene viser delene som gjentas.",
    internal: "Intern",
    public: "Offentlig",
    dragHint:
      "Dra for å endre rekkefølge. En side kan ikke forlate sin gruppe – typen fastsettes når siden opprettes.",
    deletePage: "Slett side",
    deletePageConfirmation: (name: string) => `Er du sikker på at du vil slette "${name}"?`,
    willAlsoDelete: (count: number) =>
      ` Dette vil også slette ${count} komponent(er) på denne siden.`,
    cancel: "Avbryt",
    delete: "Slett",
  },
} as const;
